<app-expandable-section-box
  [title]="'Surtitle'"
  [iconClass]="'icon-bookmark'"
  [isExpandable]="isExpandable"
  [isExpandedByDefault]="isExpandedByDefault"
>
  <div class="flex flex-col flex-1 py-3" expandedContent>
    <div class="w-full py-2 mb-2 text-center text-gray-700 bg-gray-200 rounded">
      <ng-container *ngIf="surtitleControl.value[0]; else noSurtitles">
        <div class="w-11/12 max-w-full px-2 mx-auto text-xs">
          <div class="flex flex-col">
            <div class="flex items-center mb-2">
              <p class="flex-1 font-normal text-left text-gray-500 text-xxs">
                <span class="font-semibold">
                  '{{ surtitleControl.value[0].name }}'
                </span>
                {{
                  getSurtitleTypeString(
                    SurtitleTypeString[surtitleControl.value[0].surtitleType]
                  )
                }}
                tag displayed as:
              </p>
            </div>

            <div class="flex items-center space-x-2">
              <mat-form-field class="flex-1" appearance="outline">
                <input
                  matInput
                  type="text"
                  spellcheck="false"
                  class="pl-0.5"
                  [formControl]="surtitleDisplayNameInput"
                  placeholder="Edit display name"
                />
              </mat-form-field>
              <button
                class="border-none text-xxs bg-none text-project-100 hover:cursor-pointer hover:text-project-2700"
                data-testid="removeBtn"
                title="Remove"
                (click)="removeSurtitle()"
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #noSurtitles>No surtitle selected</ng-template>
    </div>

    <div *ngIf="typedTags.length">
      <h3 class="mt-2 mb-3 text-xs font-semibold text-gray-600 subtitle">
        Select an existing tag
      </h3>
    </div>

    <div
      *ngIf="typedTags.length"
      class="max-h-[300px] overflow-y-auto border border-gray-300 rounded-lg p-3"
    >
      <div *ngIf="existingTopicTags.length">
        <h3 class="font-semibold text-xxs subtitle">Topics</h3>
        <ul class="flex flex-wrap gap-2 my-1.5">
          <li *ngFor="let tag of existingTopicTags">
            <app-tag-button
              [tag]="tag"
              [surtitleTagType]="SurtitleTagType.Topic"
              [surtitleControl]="surtitleControl"
              (tagSelected)="onSelectExistingTag($event)"
            ></app-tag-button>
          </li>
        </ul>
      </div>

      <div *ngIf="existingTags.length">
        <h3 class="font-semibold text-xxs subtitle">Tags</h3>
        <ul class="flex flex-wrap gap-2 my-1.5">
          <li *ngFor="let tag of existingTags">
            <app-tag-button
              [tag]="tag"
              [surtitleTagType]="SurtitleTagType.Soft"
              [surtitleControl]="surtitleControl"
              (tagSelected)="onSelectExistingTag($event)"
            ></app-tag-button>
          </li>
        </ul>
      </div>

      <div *ngIf="existingCompanyTags.length">
        <h3 class="font-semibold text-xxs subtitle">Companies</h3>
        <ul class="flex flex-wrap gap-2 my-1.5">
          <li *ngFor="let tag of existingCompanyTags">
            <app-tag-button
              [tag]="tag"
              [surtitleTagType]="SurtitleTagType.Company"
              [surtitleControl]="surtitleControl"
              (tagSelected)="onSelectExistingTag($event)"
            ></app-tag-button>
          </li>
        </ul>
      </div>

      <div *ngIf="existingManagerTags.length">
        <h3 class="font-semibold text-xxs subtitle">Managers</h3>
        <ul class="flex flex-wrap gap-2 my-1.5">
          <li *ngFor="let tag of existingManagerTags">
            <app-tag-button
              [tag]="tag"
              [surtitleTagType]="SurtitleTagType.Manager"
              [surtitleControl]="surtitleControl"
              (tagSelected)="onSelectExistingTag($event)"
            ></app-tag-button>
          </li>
        </ul>
      </div>

      <div *ngIf="existingFundTags.length">
        <h3 class="font-semibold text-xxs subtitle">Funds</h3>
        <ul class="flex flex-wrap gap-2 my-1.5">
          <li *ngFor="let tag of existingFundTags">
            <app-tag-button
              [tag]="tag"
              [surtitleTagType]="SurtitleTagType.Fund"
              [surtitleControl]="surtitleControl"
              (tagSelected)="onSelectExistingTag($event)"
            ></app-tag-button>
          </li>
        </ul>
      </div>

      <div *ngIf="existingSectorTags.length">
        <h3 class="font-semibold text-xxs subtitle">Sectors</h3>
        <ul class="flex flex-wrap gap-2 my-1.5">
          <li *ngFor="let tag of existingSectorTags">
            <app-tag-button
              [tag]="tag"
              [surtitleTagType]="SurtitleTagType.Sector"
              [surtitleControl]="surtitleControl"
              (tagSelected)="onSelectExistingTag($event)"
            ></app-tag-button>
          </li>
        </ul>
      </div>

      <div *ngIf="existingAssetClassTags.length">
        <h3 class="font-semibold text-xxs subtitle">Asset Classes</h3>
        <ul class="flex flex-wrap gap-2 my-1.5">
          <li *ngFor="let tag of existingAssetClassTags">
            <app-tag-button
              [tag]="tag"
              [surtitleTagType]="SurtitleTagType.AssetClass"
              [surtitleControl]="surtitleControl"
              (tagSelected)="onSelectExistingTag($event)"
            ></app-tag-button>
          </li>
        </ul>
      </div>

      <div *ngIf="existingInvestmentTrustTags.length">
        <h3 class="font-semibold text-xxs subtitle">Investment Trusts</h3>
        <ul class="flex flex-wrap gap-2 my-1.5">
          <li *ngFor="let tag of existingInvestmentTrustTags">
            <app-tag-button
              [tag]="tag"
              [surtitleTagType]="SurtitleTagType.InvestmentTrust"
              [surtitleControl]="surtitleControl"
              (tagSelected)="onSelectExistingTag($event)"
            ></app-tag-button>
          </li>
        </ul>
      </div>

      <div *ngIf="existingShareTags.length">
        <h3 class="font-semibold text-xxs subtitle">Shares</h3>
        <ul class="flex flex-wrap gap-2 my-1.5">
          <li *ngFor="let tag of existingShareTags">
            <app-tag-button
              [tag]="tag"
              [surtitleTagType]="SurtitleTagType.Share"
              [surtitleControl]="surtitleControl"
              (tagSelected)="onSelectExistingTag($event)"
            ></app-tag-button>
          </li>
        </ul>
      </div>
    </div>

    <div>
      <h3
        *ngIf="typedTags.length"
        class="mt-2 mb-3 text-xs font-semibold text-gray-600 subtitle"
      >
        Or
      </h3>
      <app-search-list
        *ngIf="isShowingSurtitles"
        expandedContent
        [selectedList]="selectedSurtitleList"
        [searchFormControl]="searchSoftTagFormControl"
        [searchResults]="softTagSearchResults"
        [isInfoButtonShown]="false"
        [isAddButtonShown]="false"
        [placeholder]="'Use or create a soft tag'"
        [isSurtitles]="true"
        (handleAdd)="addSoftTagAsSurtitle($event)"
        class="flex flex-col flex-1 w-full pt-2"
      ></app-search-list>
      <button
        mat-stroked-button
        class="mx-2 mt-4 mb-2"
        *ngIf="
          !isSearchingSurtitles &&
          softTagSearchResults?.length === 0 &&
          searchSoftTagFormControl.value != ''
        "
        (click)="createSoftTag(searchSoftTagFormControl.value)"
      >
        <i class="icon icon-plus"></i> Add Surtitle
      </button>
    </div>
  </div>

  <div class="flex flex-col flex-1" notExpandedContent>
    <div
      class="flex flex-col w-full py-2 pr-3 m-0 bg-project-2200"
      *ngIf="surtitleControl.value?.length"
      data-testid="surtitle"
    >
      <p class="w-full py-px font-semibold text-xxs text-project-2400">
        {{
          getSurtitleTypeString(
            SurtitleTypeString[surtitleControl.value[0].surtitleType]
          )
        }}
      </p>

      <p class="w-full py-px text-xs text-project-2400">
        {{ surtitleControl.value[0].name }}
      </p>

      <p
        *ngIf="
          surtitleControl.value[0].displayText &&
          surtitleControl.value[0].name !== surtitleControl.value[0].displayText
        "
        class="w-full py-px text-xs text-project-2400"
      >
        <span class="font-semibold">Display Name: </span
        >{{ surtitleControl.value[0].displayText }}
      </p>
    </div>
  </div>
</app-expandable-section-box>
